/* import __COLOCATED_TEMPLATE__ from './pix-filterable-and-searchable-select.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
let PixFilterableAndSearchableSelect = (_class = class PixFilterableAndSearchableSelect extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "elementHelper", _descriptor, this);
    _initializerDefineProperty(this, "selectedCategories", _descriptor2, this);
    this.mainId = 'pix-pfass-' + guidFor(this);
    this.pixSelectId = 'pix-pfass-select-' + guidFor(this);
    this.pixMultiSelectId = 'pix-pfass-multi-select-' + guidFor(this);
    this.elementHelper.waitForElement(this.pixSelectId).then(() => {
      const baseFontRemRatio = Number(getComputedStyle(document.querySelector('html')).fontSize.match(/\d+(\.\d+)?/)[0]);
      const multiSelectWidth = document.getElementById(this.pixMultiSelectId).getBoundingClientRect().width;
      const selectWidth = Math.ceil(multiSelectWidth / baseFontRemRatio);
      const className = `sizing-select-${this.pixSelectId}`;
      this.elementHelper.createClass(`.${className}`, `width: calc(100% - ${selectWidth}rem);`);
      const element = document.getElementById(`container-${this.pixSelectId}`);
      element.className = element.className + ' ' + className;
    });
  }
  selectCategories(categories) {
    this.selectedCategories = categories;
  }
  get categories() {
    const categoryNames = [];
    this.args.options.forEach(option => {
      if (!categoryNames.includes(option.category)) {
        categoryNames.push(option.category);
      }
    });
    return categoryNames.map(category => {
      return {
        label: category,
        value: category
      };
    });
  }
  get categoriesPlaceholder() {
    return `${this.args.categoriesPlaceholder} (${this.selectedCategories.length})`;
  }
  get selectableOptions() {
    const selectableOptions = [];
    const categories = this.selectedCategories.length === 0 ? this.categories.map(({
      value
    }) => value) : this.selectedCategories;
    this.args.options.forEach(option => {
      if (categories.includes(option.category)) {
        selectableOptions.push(option);
      }
    });
    return selectableOptions;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "elementHelper", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedCategories", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "selectCategories", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectCategories"), _class.prototype), _class);
export { PixFilterableAndSearchableSelect as default };